import { gql } from '@apollo/client';

export const PEOPLE_FRAGMENT = gql`
  fragment PeopleFragment on Person {
    id
    fullName
  }
`;
